import { createSlice } from '@reduxjs/toolkit'
import { analyticsService } from '../services/analyticsService'
import { db } from '../lib/database'

const initialState = {
  stats: { total_assigned_forms: 0, total_submissions: 0, submissions_today: 0, response_rate: 0, last_7_days_submissions: {} },
  status: 'idle',
  error: null,
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setStatsLoading: (state) => {
      if (state.status === 'idle') {
        state.status = 'loading'
      }
    },
    setStatsSucceeded: (state, action) => {
      state.stats = {
        total_assigned_forms: action.payload.total_assigned_forms || 0,
        total_submissions: action.payload.total_submissions || 0,
        submissions_today: action.payload.submissions_today || 0,
        response_rate: action.payload.response_rate || 0,
        last_7_days_submissions: action.payload.last_7_days_submissions || {},
      }
      state.status = 'succeeded'
    },
    setStatsFailed: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
    resetDashboard: () => initialState,
  },
})

export const { setStatsLoading, setStatsSucceeded, setStatsFailed, resetDashboard } = dashboardSlice.actions

export const fetchDashboardStats = (forceRefresh = false) => (dispatch, getState) => {
  const { status } = getState().dashboard

  if (status === 'loading' && !forceRefresh) {
    return Promise.resolve()
  }
  
  dispatch(setStatsLoading())

  const loadFromDb = () => {
    return db.settings.get('dashboardStats').then(cachedStats => {
      if (cachedStats?.value) {
        dispatch(setStatsSucceeded(cachedStats.value))
        return true
      }
      return false
    })
  }

  return loadFromDb().then(loaded => {
    if (navigator.onLine) {
      return analyticsService.fetchStats()
        .then(response => {
          if (response?.data) {
            const statsData = response.data.data || response.data
            dispatch(setStatsSucceeded(statsData))
            return db.settings.put({ key: 'dashboardStats', value: statsData })
          }
        })
        .catch(() => {
          return db.settings.get('dashboardStats').then(cached => {
            if (!cached) dispatch(setStatsFailed('Failed to fetch stats.'))
          })
        })
    } else {
      if (!loaded) {
        dispatch(setStatsFailed('You are offline and no stats are saved.'))
      }
    }
  })
}

export default dashboardSlice.reducer